<div class="mon-dialog-header">
  <h3 class="pt-6 mt-3 inline-block">
    <span class="inline-block" *ngIf="!downloadDone" translate>
      Select your export file
    </span>
    <span data-test="export-being-generated-text" class="inline-block" *ngIf="downloadDone" translate>
      Your export is currently being generated.
    </span>
  </h3>
  </div>

<div class="mon-dialog-body auto-scroll">
  <div class="row pb-3" *ngIf="downloadDone">
    <div class="col-48 pt-3 px-6">
      <p translate class="text-bold">
        You will receive an email when the export is ready.
      </p>
      <p translate>
        To see the current progress, click the user avatar on the upper right-hand side of the main page and select <span class="text-bold">My Exports.</span>
      </p>
      <p translate>Alternatively, click the button below.</p>
      <button
        data-test="go-to-exports-button"
        (click)="goToExports()"
        mon-event-trigger="actionTrigger"
        mon-event-params="{ action: 'open-my-exports-btn' }"
        class="mt-3 btn-block btn btn-border-radius btn-secondary py-6"
      >
        <span class="fas fa-fw fa-lg fa-file-download mr-2" aria-hidden="true"></span>
        <span class="inline-block font-size-1-1" translate>
          Go to My Exports
        </span>
      </button>
    </div>
  </div>

  <div class="row pb-3" *ngIf="!downloadDone">
    <div class="col-48 pt-3 px-6 text-center" *ngIf="onDownload">
      <span class="fas mt-4 fa-spinner fa-spin fa-2x" aria-hidden="true"></span>
    </div>
    <ng-container *ngFor="let export of exports; let i = index">
      <div
        class="col-48 pt-3 px-6"
        *ngIf="!onDownload"
        [placement]="'bottom'"
        [ngbTooltip]="export.tooltip"
      >
        <div class="text-center" *ngIf="export.inputs">
          <span class="inline-block font-size-1-1" style="cursor: default;">
            {{ export.inputs[0].description }}
            <span
              [placement]="'bottom'"
              [ngbTooltip]="'Click here to edit' | translate"
              (click)="confirm = true"
              class="text-dark"
              *ngIf="!confirm"
              style="cursor: default;"
              (keydown.enter)="confirm = true"
            >
              <span class="text-underline cursor-pointer">{{ export.inputs[0].default }}</span>
            </span>
            <input
              *ngIf="confirm && !modify"
              style="cursor: default;"
              [(ngModel)]="export.inputs[0].default"
              type="number"
            />
            <span translate>rows - click to change</span>
            <button
              type="button"
              *ngIf="confirm"
              class="btn btn-border-radius btn-secondary"
              (click)="modifyDefaultExportNumber()"
            >
              <span class="fas fa-check"></span>
            </button>
            <button
              type="button"
              *ngIf="confirm"
              class="btn btn-border-radius btn-dark"
              (click)="confirm = false; export.inputs[0].default = 1000"
            >
              <span class="fas fa-times"></span>
            </button>
          </span>
        </div>
        <br *ngIf="export.inputs" />
        <div class="text-center" *ngIf="export.note">
          <span class="inline-block font-size-1-1">
            <span translate>Note</span>:&nbsp;{{ export.note.message }}
          </span>
        </div>
        <br *ngIf="export.note" />
        <button
          type="button"
          [attr.data-test]="'export-' + export.name"
          class="btn-block btn btn-border-radius btn-secondary py-6"
          (click)="download(export.data, i)"
          mon-event-trigger="actionTrigger"
          mon-event-params="{ action: 'btn-export', params: vm.params }"
        >
          <span class="fas fa-2x fa-download mr-2 inline-block" aria-hidden="true"></span>
          <span class="inline-block font-size-1-1 text-capitalize">
            {{ export.name || startExportTxt }}
          </span>
        </button>
  </div>
</ng-container>
</div>